export var checkIsClientSide = function checkIsClientSide() {
  return typeof window !== 'undefined';
};
export var ymPushParams = function ymPushParams() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 26001372;
  if (checkIsClientSide() && window.ym) {
    // @ts-expect-error ym was defined in @beef/metric
    window.ym(id, 'params', payload);
  }
};
export var ymReachGoal = function ymReachGoal(alias, params) {
  if (checkIsClientSide() && window.ym) {
    // @ts-expect-error ym was defined in @beef/metric
    window.ym(26001372, 'reachGoal', alias, params);
  }
};